import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, catchError, throwError, tap } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AuthService } from '../auth-service';
import {
  GetReasonsQueryParams,
  PPReasonListResponse,
  ApiErrorResponse,
} from '../../pages/admin-dashboard/partially-package-reasons/reasons-list/p-p-reason-list.model';

@Injectable({
  providedIn: 'root',
})
export class PPReasonListService {
  private http = inject(HttpClient);
  private authService = inject(AuthService);

  private readonly API = environment.pharmacyMgtApiUrl;
  private readonly ENDPOINT = `${this.API}/orders/partially/package/reasons`;

  private getAuthHeaders(): HttpHeaders {
    const token = this.authService.getAccessToken();
    let headers = new HttpHeaders();
    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }
    return headers;
  }

  private buildParams(queryParams: GetReasonsQueryParams): HttpParams {
    let params = new HttpParams();

    if (queryParams.quickSearch) {
      params = params.set('quickSearch', queryParams.quickSearch);
    }
    if (queryParams.pageNum !== undefined && queryParams.pageNum !== null) {
      params = params.set('pageNum', queryParams.pageNum.toString());
    }
    if (queryParams.pageSize !== undefined && queryParams.pageSize !== null) {
      params = params.set('pageSize', queryParams.pageSize.toString());
    }
    if (queryParams.orderBy) {
      params = params.set('orderBy', queryParams.orderBy);
    }
    if (queryParams.orderDir) {
      params = params.set('orderDir', queryParams.orderDir);
    }
    if (queryParams.createdOnFrom) {
      params = params.set('createdOnFrom', queryParams.createdOnFrom);
    }
    if (queryParams.createdOnTo) {
      params = params.set('createdOnTo', queryParams.createdOnTo);
    }
    if (queryParams.lastModifiedOnFrom) {
      params = params.set('lastModifiedOnFrom', queryParams.lastModifiedOnFrom);
    }
    if (queryParams.lastModifiedOnTo) {
      params = params.set('lastModifiedOnTo', queryParams.lastModifiedOnTo);
    }

    return params;
  }

  getReasons(queryParams: GetReasonsQueryParams): Observable<PPReasonListResponse> {
    const headers = this.getAuthHeaders();
    const params = this.buildParams(queryParams);

    return this.http.get<PPReasonListResponse>(this.ENDPOINT, { params, headers }).pipe(
      tap((response) => console.log(`✓ Retrieved ${response.list?.length ?? 0} of ${response.total} reasons`)),
      catchError(this.handleError),
    );
  }

  private handleError(error: HttpErrorResponse): Observable<never> {
    const apiError: ApiErrorResponse = error.error;
    return throwError(() => apiError);
  }
}
